<!-- TODO: A supprimer quand l'implémentation v10 sera terminée -->
<custom-frame [frame]="'traductionReferentiels'" [isTitleHidden]="true"></custom-frame>